import { render, staticRenderFns } from "./MantenedorGridSinCodigo.vue?vue&type=template&id=0c19fd10&"
import script from "./MantenedorGridSinCodigo.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridSinCodigo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c19fd10', component.options)
    } else {
      api.reload('0c19fd10', component.options)
    }
    module.hot.accept("./MantenedorGridSinCodigo.vue?vue&type=template&id=0c19fd10&", function () {
      api.rerender('0c19fd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/MantenedorGridSinCodigo.vue"
export default component.exports